import React, { useState, useEffect, useRef } from 'react';
import { getQuotationRequest, getPurchaseOrderById, getMachineRequest, createInstallation } from '../../services/mm/apiController';
import { useSelector } from 'react-redux';
import { factoryId, loggedInUser } from '../../store/reducers/account_reducer';
import { destroy } from '../../services/apiController';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { formatDate } from '../../util/helper';
import { DeleteIcon, DownloadIcon } from '../vm/components/icons';
import { toast, ToastContainer } from 'react-toastify';
import { Row, Col, Modal, Button, Form, FloatingLabel } from 'react-bootstrap';
import '../../style/switch.css';
import AlertIcon from './../../img.svg';
import axios from 'axios';
import { getStoredData, get_auth_key } from '../../util';

const PurchaseOrderDetails = () => {
  let params = useParams();
  const factoryId_ = useSelector(factoryId);
  const storedData = JSON.parse(getStoredData(get_auth_key()));
  const [show, setShow] = useState(false);
  const [purchaseOrderDetail, setPurchaseOrderDetail] = useState('');
  const [quotationDetail, setQuotationDetail] = useState('');
  const [machineRequestDetail, setMachineRequestDetail] = useState('');
  const formFields = {
    item: '',
    itemNumber: '',
    section: '',
    charges: '',
    description: '',
    installationDate: '',
    location: '',
    requestId: '',
    purchaseId: '',
    manual: null,
    userManual: null,
    warranty: false,
    warrantyPeriod: '',
    technitionName: '',
    technitionContactNumber: '',
    status: 'INSTALLED',
    file1: null,
    file_1: null,
    file2: null,
    file_2: null,
    file3: null,
    file_3: null,
    file4: null,
    file_4: null,
    file5: null,
    file_5: null,
    factoryId: factoryId_,
    createdBy: '02a08619-56a5-4c94-9728-94f4e4d2a1c8',
  };
  const [purchaseOrderForm, setPurchaseOrderForm] = useState(formFields);
  const [documentShowConfirmModel, setDocumentShowConfirmModel] = useState(false);
  const handleCloseDocumentConfirmModal = () => {
    setDocumentShowConfirmModel(false);
  };
  const [fieldToDeleted, setFieldToDeleted] = useState('');
  const [purchaseDocumentShowConfirmModel, setPurchaseDocumentShowConfirmModel] = useState(false);
  const handleClosePurchaseDocumentConfirmModal = () => {
    setPurchaseDocumentShowConfirmModel(false);
  };
  const [purchaseFieldToDeleted, setPurchaseFieldToDeleted] = useState('');
  const clickToDownload = useRef(null);
  const [invalidFileType, setInvalidFileType] = useState(false);

  let navigate = useNavigate();
  const handleToggle = (e) => {
    const { checked } = e.target;
    setPurchaseOrderForm({ ...purchaseOrderForm, warranty: checked });
  };

  const handleShowDocumentConfirmModal = (e, field) => {
    e.preventDefault();
    setDocumentShowConfirmModel(true);
    setFieldToDeleted(field);
  };
  const handleShowPurchaseDocumentConfirmModal = (e, field) => {
    e.preventDefault();
    setPurchaseDocumentShowConfirmModel(true);
    setPurchaseFieldToDeleted(field);
  };

  const handleClose = () => {
    setShow(false);
  };
  const handleShow = async () => {
    await setPurchaseOrderForm({
      ...purchaseOrderForm,
      location: purchaseOrderDetail?.factory?.name,
    });
    setShow(true);
  };

  const handleChange = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setPurchaseOrderForm({ ...purchaseOrderForm, [name]: value });
  };

  const onChangeManual = (e) => {
    e.preventDefault();
    if (e.target.files[0] && e.target.files[0].name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      setPurchaseOrderForm({ ...purchaseOrderForm, manual: null, userManual: '' });
      toast.error('Please select a valid file type.');
    } else {
      const file = e.target.files[0] || null;

      const formData = new FormData();
      formData.append('fileName', file);

      axios
        .post(process.env.REACT_APP_BASE_URL + '/mm/file', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'x-access-token': storedData.token,
          },
        })
        .then((resp) => {
          if (resp.status === 200) {
            // Handle success
            setPurchaseOrderForm({ ...purchaseOrderForm, userManual: resp.data });
            toast.success('File uploaded successfully.');
          } else {
            // Handle other status codes if needed
            toast.error('Failed to upload file.');
          }
        })
        .catch((err) => {
          // Handle error
          console.log(err);
          toast.error('Error');
        });
    }
  };

  const onChangeWarrantyDocument = (e) => {
    e.preventDefault();
    if (e.target.files[0] && e.target.files[0].name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      setPurchaseOrderForm({ ...purchaseOrderForm, file1: null, file_1: '' });
      toast.error('Please select a valid file type.');
    } else {
      const file = e.target.files[0] || null;

      const formData = new FormData();
      formData.append('fileName', file);

      axios
        .post(process.env.REACT_APP_BASE_URL + '/mm/file', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'x-access-token': storedData.token,
          },
        })
        .then((resp) => {
          if (resp.status === 200) {
            // Handle success
            setPurchaseOrderForm({ ...purchaseOrderForm, file_1: resp.data });
            toast.success('File uploaded successfully.');
          } else {
            // Handle other status codes if needed
            toast.error('Failed to upload file.');
          }
        })
        .catch((err) => {
          // Handle error
          console.log(err);
          toast.error('Error');
        });
    }
  };
  const onChangeBill = (e) => {
    e.preventDefault();
    if (e.target.files[0] && e.target.files[0].name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      setPurchaseOrderForm({ ...purchaseOrderForm, file2: null, file_2: '' });
      toast.error('Please select a valid file type.');
    } else {
      const file = e.target.files[0] || null;

      const formData = new FormData();
      formData.append('fileName', file);

      axios
        .post(process.env.REACT_APP_BASE_URL + '/mm/file', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'x-access-token': storedData.token,
          },
        })
        .then((resp) => {
          if (resp.status === 200) {
            // Handle success
            setPurchaseOrderForm({ ...purchaseOrderForm, file_2: resp.data });
            toast.success('File uploaded successfully.');
          } else {
            // Handle other status codes if needed
            toast.error('Failed to upload file.');
          }
        })
        .catch((err) => {
          // Handle error
          console.log(err);
          toast.error('Error');
        });
    }
  };
  const onChangeMachineImage1 = (e) => {
    e.preventDefault();
    if (e.target.files[0] && e.target.files[0].name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      setPurchaseOrderForm({ ...purchaseOrderForm, file3: null, file_3: '' });
      toast.error('Please select a valid file type.');
    } else {
      const file = e.target.files[0] || null;

      const formData = new FormData();
      formData.append('fileName', file);

      axios
        .post(process.env.REACT_APP_BASE_URL + '/mm/file', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'x-access-token': storedData.token,
          },
        })
        .then((resp) => {
          if (resp.status === 200) {
            // Handle success
            setPurchaseOrderForm({ ...purchaseOrderForm, file_3: resp.data });
            toast.success('File uploaded successfully.');
          } else {
            // Handle other status codes if needed
            toast.error('Failed to upload file.');
          }
        })
        .catch((err) => {
          // Handle error
          console.log(err);
          toast.error('Error');
        });
    }
  };
  const onChangeMachineImage2 = (e) => {
    e.preventDefault();
    if (e.target.files[0] && e.target.files[0].name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      setPurchaseOrderForm({ ...purchaseOrderForm, file4: null, file_4: '' });
      toast.error('Please select a valid file type.');
    } else {
      const file = e.target.files[0] || null;

      const formData = new FormData();
      formData.append('fileName', file);

      axios
        .post(process.env.REACT_APP_BASE_URL + '/mm/file', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'x-access-token': storedData.token,
          },
        })
        .then((resp) => {
          if (resp.status === 200) {
            // Handle success
            setPurchaseOrderForm({ ...purchaseOrderForm, file_4: resp.data });
            toast.success('File uploaded successfully.');
          } else {
            // Handle other status codes if needed
            toast.error('Failed to upload file.');
          }
        })
        .catch((err) => {
          // Handle error
          console.log(err);
          toast.error('Error');
        });
    }
  };
  const onChangeMachineImage3 = (e) => {
    e.preventDefault();
    if (e.target.files[0] && e.target.files[0].name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      setPurchaseOrderForm({ ...purchaseOrderForm, file5: null, file_5: '' });
      toast.error('Please select a valid file type.');
    } else {
      const file = e.target.files[0] || null;

      const formData = new FormData();
      formData.append('fileName', file);

      axios
        .post(process.env.REACT_APP_BASE_URL + '/mm/file', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'x-access-token': storedData.token,
          },
        })
        .then((resp) => {
          if (resp.status === 200) {
            // Handle success
            setPurchaseOrderForm({ ...purchaseOrderForm, file_5: resp.data });
            toast.success('File uploaded successfully.');
          } else {
            // Handle other status codes if needed
            toast.error('Failed to upload file.');
          }
        })
        .catch((err) => {
          // Handle error
          console.log(err);
          toast.error('Error');
        });
    }
  };

  useEffect(() => {
    getPurchaseOrder();
  }, []);

  const getPurchaseOrder = async () => {
    const PurchaseOrderVal = await getPurchaseOrderById(params.purchaseId);
    setPurchaseOrderDetail(PurchaseOrderVal.data);
  };

  useEffect(() => {
    if (purchaseOrderDetail !== '') {
      getSingleQuotation();
      getVR();
    }
  }, [purchaseOrderDetail]);

  const getSingleQuotation = async () => {
    const quotationVal = await getQuotationRequest(purchaseOrderDetail?.quotationId);
    setQuotationDetail(quotationVal.data);
  };

  const getVR = async () => {
    const machineRequest = await getMachineRequest(purchaseOrderDetail?.requestId);
    setMachineRequestDetail(machineRequest.data);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (invalidFileType) {
      toast.error('Please select a valid file.', { autoClose: 2000 });
      return;
    }
    if (!purchaseOrderForm.itemNumber || !purchaseOrderForm.charges || !purchaseOrderForm.installationDate || !purchaseOrderForm.location) {
      toast.error('Please fill in all the required fields.');
      return;
    }
    purchaseOrderForm.item = await machineRequestDetail?.model;
    purchaseOrderForm.requestId = await machineRequestDetail?.id;
    purchaseOrderForm.purchaseId = await purchaseOrderDetail?.id;
    purchaseOrderForm.section = await machineRequestDetail?.section;
    try {
      await createInstallation(purchaseOrderForm);
      toast.success('Installation added successfully');
      getPurchaseOrder();
      setShow(false);
      getVR();
      navigate('/mm/Installation');
    } catch (err) {
      toast.error(err?.response?.data?.data?.message || err?.message || 'Something went wrong', { autoClose: 3000 });
    }
  };

  const deletePurchaseOrderFile = (field) => {
    try {
      destroy(`/mm/purchase-order/filefrom/${purchaseOrderDetail.id}/${field}`)
        .then((resp) => {
          setPurchaseDocumentShowConfirmModel(false);
          setPurchaseOrderDetail(resp.data);
        })
        .catch((error) => {
          toast.error(error.message);
        });
    } catch (e) {
      toast.error(e.message);
    }
  };
  const deleteQuotationFile = (field) => {
    try {
      destroy(`/mm/quotation/filefrom/${quotationDetail.id}/${field}`)
        .then((resp) => {
          setDocumentShowConfirmModel(false);
          setQuotationDetail(resp.data);
        })
        .catch((error) => {
          toast.error(error.message);
        });
    } catch (e) {
      toast.error(e.message);
    }
  };

  const handleDownload = async (e, id) => {
    e.preventDefault();
    try {
      const requestOptions = {
        method: 'GET',
        headers: {
          'x-access-token': storedData.token,
        },
      };
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/mm/purchase-order/reportById/${id}`, requestOptions);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      clickToDownload.current.href = url;
      clickToDownload.current.setAttribute('download', purchaseOrderDetail.item);
      setTimeout(() => {
        clickToDownload.current.click();
      }, 500);
    } catch (err) {
      console.error(err);
      toast.error(err.message);
    }
  };

  return (
    <React.Fragment>
      <ToastContainer />
      <nav className="" aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <Link to="/mm/purchase-orders">Purchase Order List</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to={`/mm/purchase-orders/${purchaseOrderDetail.id}`}>Purchase Order Detail</Link>
          </li>
        </ol>
      </nav>
      <div className="card">
        <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
          <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
            Purchase Order Detail
          </h4>
          <a ref={clickToDownload} href="" target="_blank" className="hiddenItem">
            HiddenClick
          </a>
          <button type="button" onClick={(e) => handleDownload(e, purchaseOrderDetail.id)} className="btn app-btn-default dark-color">
            Download Report
          </button>
        </div>
        <div className="card-body">
          <Row className="top-row">
            <div className="col-md-2">
              <dd className="display-title mb-1">PO Number</dd>
              <dt className="display-value">{purchaseOrderDetail.poNumber}</dt>
            </div>
            <div className="col-md-2">
              <dd className="display-title mb-1">Machine Name</dd>
              <dt className="display-value">{purchaseOrderDetail.item}</dt>
            </div>
            <div className="col-md-2">
              <dd className="display-title mb-1">Amount</dd>
              <dt className="display-value">{purchaseOrderDetail?.quotation?.price}</dt>
            </div>
            <div className="col-md-2">
              <dd className="display-title mb-1">Approved By</dd>
              <dt className="display-value">{purchaseOrderDetail.initiatedBy}</dt>
            </div>
            <div className="col-md-2">
              <dd className="display-title mb-1">Approved Date</dd>
              <dt className="display-value">{formatDate(purchaseOrderDetail?.approvedDate)}</dt>
            </div>
            <div className="col-md-2">
              <dd className="display-title mb-1">Factory</dd>
              <dt className="display-value">{purchaseOrderDetail?.factory?.name}</dt>
            </div>
          </Row>

          <Row>
            {purchaseOrderDetail.file_1 || purchaseOrderDetail.file_2 || purchaseOrderDetail.file_3 ? (
              <Col xs={4}>
                <h6>Downloads</h6>
                <ul className="list-group">
                  {purchaseOrderDetail.file_1 !== null ? (
                    <li className="list-group-item">
                      <Row>
                        <Col xs={8} className="file-name">
                          {purchaseOrderDetail.file_1}
                        </Col>
                        <Col xs={4} className="text-end actions">
                          <a href={`${process.env.REACT_APP_BASE_URL}/file/download?filePath=${purchaseOrderDetail.file_1}`}>
                            <DownloadIcon />
                          </a>
                          <DeleteIcon onClick={(e) => handleShowPurchaseDocumentConfirmModal(e, 'file_1')} />
                        </Col>
                      </Row>
                    </li>
                  ) : (
                    ''
                  )}
                  {purchaseOrderDetail.file_2 !== null ? (
                    <li className="list-group-item">
                      <Row>
                        <Col xs={8} className="file-name">
                          {purchaseOrderDetail.file_2}
                        </Col>
                        <Col xs={4} className="text-end actions">
                          <a href={`${process.env.REACT_APP_BASE_URL}/file/download?filePath=${purchaseOrderDetail.file_2}`}>
                            <DownloadIcon />
                          </a>
                          <DeleteIcon
                            onClick={(e) => handleShowPurchaseDocumentConfirmModal(e, 'file_2')}
                            style={{ color: 'rgb(220, 53, 69)', cursor: 'pointer' }}
                          />
                        </Col>
                      </Row>
                    </li>
                  ) : (
                    ''
                  )}
                  {purchaseOrderDetail.file_3 !== null ? (
                    <li className="list-group-item">
                      <Row>
                        <Col xs={8} className="file-name">
                          {purchaseOrderDetail.file_3}
                        </Col>
                        <Col xs={4} className="text-end actions">
                          <a href={`${process.env.REACT_APP_BASE_URL}/file/download?filePath=${purchaseOrderDetail.file_3}`}>
                            <DownloadIcon />
                          </a>
                          <DeleteIcon
                            onClick={(e) => handleShowPurchaseDocumentConfirmModal(e, 'file_3')}
                            style={{ color: 'rgb(220, 53, 69)', cursor: 'pointer' }}
                          />
                        </Col>
                      </Row>
                    </li>
                  ) : (
                    ''
                  )}
                </ul>
              </Col>
            ) : (
              ''
            )}
            {purchaseOrderDetail.machine_request?.status === 'APPROVED' ? (
              <Col xs={5}>
                <div className="btn-wrapper">
                  <button type="button" onClick={handleShow} className="btn app-btn-primary mt-5">
                    INSTALL
                  </button>
                </div>
              </Col>
            ) : (
              ''
            )}
          </Row>
        </div>
      </div>
      {quotationDetail ? (
        <div className="card">
          <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
            <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
              Quotation Detail
            </h4>
          </div>
          <div className="card-body">
            <Row className="top-row">
              <div className="col-md-2">
                <dd className="display-title mb-1">Vendor Name</dd>
                <dt className="display-value">{quotationDetail?.vendorName}</dt>
              </div>
              <div className="col-md-2">
                <dd className="display-title mb-1">Price</dd>
                <dt className="display-value">{quotationDetail?.price}</dt>
              </div>
              <div className="col-md-2">
                <dd className="display-title mb-1">GST</dd>
                <dt className="display-value">{quotationDetail?.gst}</dt>
              </div>
              <div className="col-md-2">
                <dd className="display-title mb-1">Email</dd>
                <dt className="display-value">{quotationDetail?.email}</dt>
              </div>
              <div className="col-md-2">
                <dd className="display-title mb-1">Status</dd>
                <dt className="display-value">{quotationDetail?.status}</dt>
              </div>
              <div className="col-md-2">
                <dd className="display-title mb-1">Contact Person</dd>
                <dt className="display-value">{quotationDetail?.contactPerson}</dt>
              </div>
            </Row>
            <Row className="top-row">
              <div className="col-md-2">
                <dd className="display-title mb-1">Contact Number</dd>
                <dt className="display-value">{quotationDetail?.contactNumber}</dt>
              </div>
              <div className="col-md-2">
                <dd className="display-title mb-1">Description</dd>
                <dt className="display-value">{quotationDetail?.description}</dt>
              </div>
            </Row>
            {quotationDetail.file_1 || quotationDetail.file_2 ? (
              <Row>
                <Col xs={4}>
                  <h6>Downloads</h6>
                  <ul className="list-group">
                    {quotationDetail?.file_1 !== null ? (
                      <li className="list-group-item">
                        <Row>
                          <Col xs={8} className="file-name">
                            {quotationDetail?.file_1}
                          </Col>
                          <Col xs={4} className="text-end actions">
                            <a href={`${process.env.REACT_APP_BASE_URL}/file/download?filePath=${quotationDetail?.file_1}`}>
                              <DownloadIcon />
                            </a>
                            <DeleteIcon onClick={(e) => handleShowDocumentConfirmModal(e, 'file_1')} />
                          </Col>
                        </Row>
                      </li>
                    ) : (
                      ''
                    )}
                    {quotationDetail?.file_2 !== null ? (
                      <li className="list-group-item">
                        <Row>
                          <Col xs={8} className="file-name">
                            {quotationDetail?.fileName2}
                          </Col>
                          <Col xs={4} className="text-end actions">
                            <a href={`${process.env.REACT_APP_BASE_URL}/file/download?filePath=${quotationDetail?.file_2}`}>
                              <DownloadIcon />
                            </a>
                            <DeleteIcon onClick={(e) => handleShowDocumentConfirmModal(e, 'file_2')} />
                          </Col>
                        </Row>
                      </li>
                    ) : (
                      ''
                    )}
                  </ul>
                </Col>
              </Row>
            ) : (
              ''
            )}
          </div>
        </div>
      ) : (
        ''
      )}
      <div className="card">
        <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
          <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
            Machine Request Detail
          </h4>
        </div>
        <div className="card-body">
          <Row className="top-row">
            <div className="col-md-2">
              <dd className="display-title mb-1">Machine Name</dd>
              <dt className="display-value">{machineRequestDetail?.model}</dt>
            </div>
            <div className="col-md-2">
              <dd className="display-title mb-1">Requested Date</dd>
              <dt className="display-value">{formatDate(machineRequestDetail?.requestedDate)}</dt>
            </div>
            <div className="col-md-2">
              <dd className="display-title mb-1">Status</dd>
              <dt className="display-value">{machineRequestDetail?.status}</dt>
            </div>
            <div className="col-md-2">
              <dd className="display-title mb-1">Requested By</dd>
              <dt className="display-value">{machineRequestDetail?.requestedBy}</dt>
            </div>
            <div className="col-md-2">
              <dd className="display-title mb-1">Initiated By</dd>
              <dt className="display-value">{machineRequestDetail?.initiatedBy}</dt>
            </div>
            <div className="col-md-2">
              <dd className="display-title mb-1">Reason</dd>
              <dt className="display-value">{machineRequestDetail?.reason}</dt>
            </div>
          </Row>
          {machineRequestDetail.fiel1 || machineRequestDetail.file2}
          <Row>
            <Col xs={4}>
              <h6>Downloads</h6>
              <ul className="list-group">
                {machineRequestDetail?.file1 !== null ? (
                  <li className="list-group-item">
                    <Row>
                      <Col xs={8} className="file-name">
                        {machineRequestDetail?.file1}
                      </Col>
                      <Col xs={4} className="text-end actions">
                        <a href={`${process.env.REACT_APP_BASE_URL}/file/download?filePath=${machineRequestDetail?.file1}`}>
                          <DownloadIcon />
                        </a>
                      </Col>
                    </Row>
                  </li>
                ) : (
                  ''
                )}
                {machineRequestDetail?.file2 !== null ? (
                  <li className="list-group-item">
                    <Row>
                      <Col xs={8} className="file-name">
                        {machineRequestDetail?.file2}
                      </Col>
                      <Col xs={4} className="text-end actions">
                        <a href={`${process.env.REACT_APP_BASE_URL}/file/download?filePath=${machineRequestDetail?.file2}`}>
                          <DownloadIcon />
                        </a>
                      </Col>
                    </Row>
                  </li>
                ) : (
                  ''
                )}
              </ul>
            </Col>
          </Row>
        </div>
      </div>
      <Modal size="lg" show={show} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header>
          <Modal.Title>Add Installation</Modal.Title>
          <button type="button" className="btn-close" aria-label="Close" onClick={handleClose}></button>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Machine Name" className="mb-3">
                  <Form.Control
                    value={machineRequestDetail?.model}
                    className="input"
                    name="item"
                    type="text"
                    placeholder="Machine Name"
                    required
                    readOnly
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Section" className="mb-3">
                  <Form.Select
                    value={machineRequestDetail?.section}
                    className="input"
                    name="section"
                    placeholder="Section"
                    required
                    disabled
                  >
                    <option>{machineRequestDetail?.section}</option>
                  </Form.Select>
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Asset Number" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={purchaseOrderForm.itemNumber}
                    className="input"
                    name="itemNumber"
                    type="text"
                    placeholder="Enter Asset Number"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Additional Charges" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={purchaseOrderForm.charges}
                    className="input"
                    name="charges"
                    type="text"
                    placeholder="Enter Charges"
                    required
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Description" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={purchaseOrderForm.description}
                    className="input"
                    name="description"
                    type="text"
                    placeholder="Description"
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Installation Date" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={purchaseOrderForm.installationDate}
                    className="input"
                    name="installationDate"
                    type="date"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Location of Installation" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={purchaseOrderForm.location}
                    className="input"
                    name="location"
                    type="text"
                    placeholder="Location"
                    required
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col xs={4}>
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label className="label-text">User Manual</Form.Label>
                  <Form.Control onChange={onChangeManual} type="file" name="manual" aria-required="false" />
                </Form.Group>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col xs={12} className="blockLine my-3">
                <p className="my-0">
                  <strong>Warranty</strong>
                </p>
                <hr className="my-0" />
              </Col>
              <Col xs={5} className="warranty-btn mt-3">
                <span>Is Warranty Available?</span>
                <input
                  className="react-switch-checkbox"
                  id={`react-switch-new`}
                  type="checkbox"
                  onChange={handleToggle}
                  checked={purchaseOrderForm.warranty}
                  name="warranty"
                />
                <label className="react-switch-label" htmlFor={`react-switch-new`}>
                  <span className="no">NO</span>
                  <span className={`react-switch-button`} />
                  <span className="yes">YES</span>
                </label>
              </Col>
              {purchaseOrderForm.warranty === true ? (
                <Col xs={4} className="mt-4">
                  <FloatingLabel controlId="floatingInput" label="Warranty Covered Till" className="mt-1">
                    <Form.Control
                      onChange={handleChange}
                      value={purchaseOrderForm.warrantyPeriod}
                      className="input"
                      name="warrantyPeriod"
                      type="date"
                    />
                  </FloatingLabel>
                </Col>
              ) : (
                ''
              )}
            </Row>
            <Row className="mb-4">
              <Col xs={12} className="blockLine my-3">
                <p className="my-0">
                  <strong>Technicians details</strong>
                </p>
                <hr className="my-0" />
              </Col>
              <Col xs={4} className="mt-4">
                <FloatingLabel controlId="floatingInput" label="Technician Name">
                  <Form.Control
                    onChange={handleChange}
                    value={purchaseOrderForm.technitionName}
                    className="input"
                    name="technitionName"
                    type="text"
                    placeholder="Technician Name"
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4} className="mt-4">
                <FloatingLabel controlId="floatingInput" label="Technician Mobile">
                  <Form.Control
                    onChange={handleChange}
                    value={purchaseOrderForm.technitionContactNumber}
                    className="input"
                    name="technitionContactNumber"
                    type="text"
                    placeholder="Technician Mobile"
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col xs={12} className="blockLine my-3">
                <p className="my-0">
                  <strong>Documents</strong>
                </p>
                <hr className="my-0" />
              </Col>
              <Col xs={4} className="mt-4">
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label className="label-text">Upload Warranty Document</Form.Label>
                  <Form.Control onChange={onChangeWarrantyDocument} type="file" name="file_1" aria-required="false" />
                </Form.Group>
              </Col>
              <Col xs={4} className="mt-4">
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label className="label-text">Upload Bill</Form.Label>
                  <Form.Control onChange={onChangeBill} type="file" name="file_2" aria-required="false" />
                </Form.Group>
              </Col>
              <Col xs={4} className="mt-4">
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label className="label-text">Upload Machine Image</Form.Label>
                  <Form.Control onChange={onChangeMachineImage1} type="file" name="file_3" aria-required="false" />
                </Form.Group>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col xs={4}>
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label className="label-text">Upload Machine Image</Form.Label>
                  <Form.Control onChange={onChangeMachineImage2} type="file" name="file_4" aria-required="false" />
                </Form.Group>
              </Col>
              <Col xs={4}>
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label className="label-text">Upload Machine Image</Form.Label>
                  <Form.Control onChange={onChangeMachineImage3} type="file" name="file_5" aria-required="false" />
                </Form.Group>
              </Col>
            </Row>
            <Button onClick={handleSubmit} type="submit" className="add-request-btn mt-4 mb-3 justify-content-center">
              Add
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
      <Modal size="sm" show={documentShowConfirmModel} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header className="bg-danger text-light py-2">
          <Modal.Title>Delete Quotation Document</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-start">
            <img src={AlertIcon} alt="Alert" />
            <p className="ps-3 mb-0">Are you sure? Action cannot be undone.</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="btn-wrapper">
            <button onClick={handleCloseDocumentConfirmModal} className="btn app-btn-default btn-sm">
              Cancel
            </button>
            <button onClick={() => deleteQuotationFile(fieldToDeleted)} className="btn app-btn-danger btn-sm">
              Delete
            </button>
          </div>
        </Modal.Footer>
      </Modal>
      <Modal size="sm" show={purchaseDocumentShowConfirmModel} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header className="bg-danger text-light py-2">
          <Modal.Title>Delete Purchase Order Document</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-start">
            <img src={AlertIcon} alt="Alert" />
            <p className="ps-3 mb-0">Are you sure? Action cannot be undone.</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="btn-wrapper">
            <button onClick={handleClosePurchaseDocumentConfirmModal} className="btn app-btn-default btn-sm">
              Cancel
            </button>
            <button onClick={() => deletePurchaseOrderFile(purchaseFieldToDeleted)} className="btn app-btn-danger btn-sm">
              Delete
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default PurchaseOrderDetails;
